<template>
  <div v-if="isAdmin" class="panel-admin-body">
    <div class="title w-100">{{ title }}</div>
    <div class="container application-error-list">
      <div>
        <div class="row">
          <div class="col-3">
            <div class="form-group form-inline">
              <label for="startDate" class="mr-1">Start Date</label>
              <datepicker
                format="MMM dd yyyy"
                v-model="startDate"
                :typeable="true"
                wrapper-class=""
                input-class="form-control required w-100 bg-white"
                name="startDate"
              ></datepicker>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group form-inline ml-2">
              <label for="endDate" class="mr-1">End Date</label>
              <datepicker format="MMM dd yyyy" v-model="endDate" :typeable="true" wrapper-class="" input-class="form-control required w-100 bg-white" name="endDate"></datepicker>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group form-inline ml-2">
              <label for="application_error_client" class="mr-1">Client</label>
              <select id="application_error_client" name="application_error_client" class="custom-select required" v-model="application_error_client_id">
                <option
                  v-for="(application_error_client_option, idxapplication_error_clientOptions) in this.application_error_client_options"
                  v-bind:value="application_error_client_option.value"
                  v-bind:key="idxapplication_error_clientOptions"
                >
                  {{ application_error_client_option.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="pr-2">
            <button type="button" class="btn btn-primary ml-2" id="AddNewContentButton" @click="loadData()">Run</button>
          </div>
          <div class="pr-2">
            <button type="button" class="btn btn-primary ml-2" id="AddNewContentButton" @click="reset()">Reset</button>
          </div>
        </div>
      </div>
      <table :id="table.id" :class="table.class" cellspacing="0" width="100%">
        <thead></thead>
        <tbody></tbody>
      </table>
    </div>
  </div>
  <div v-else class="panel-admin-body no-permission-list">You do not have permission to view this page</div>
</template>

<script>
import Vue from "vue";
import $ from "jquery";

import moment from "moment";
Vue.prototype.moment = moment;
import Datepicker from "vuejs-datepicker";

import AdminMixins from "../../mixins/AdminMixins.vue";
import DataTableMixins from "../../mixins/DataTableMixins.vue";
import AdminService from "../../services/admin.service";
import TableService from "../../services/table.service";
import AlertService from "../../services/alert.service";

export default {
  name: "ApplicationErrorList",
  mixins: [AdminMixins, DataTableMixins],
  components: { Datepicker },
  data() {
    return {
      title: "Application Error List",
      table: TableService.getApplicationErrorListTableAttributes(),
      startDate: new Date(2020, 0, 1),
      endDate: new Date(),
      application_error_client_id: 0,
      application_error_client_options: [
        { name: "Select Client", value: 0 },
        { name: "No Client", value: -1 }
      ]
    };
  },
  methods: {
    reset() {
      this.application_error_client_id = 0;
      this.startDate = new Date(2020, 0, 1);
      this.endDate = new Date();
    },
    async getTableData() {
      this.$root.processServerRequest("Loading table data");
      this.startDate.setHours(12, 0, 0, 0);
      this.endDate.setHours(12, 0, 0, 0);
      AdminService.getApplicationErrorList(this.startDate, this.endDate, this.application_error_client_id, this.getApplicationErrorListCallback, this);
    },
    getApplicationErrorListCallback(response) {
      this.$root.processServerResponse();
      this.application_error_client_options = response.data.data.applicationErrorClientOptions;
      this.table.data = response.data.data.applicationErrorList;
      $.extend(this.table.configuration, { columns: this.table.columns });
      $.extend(this.table.configuration, { data: this.table.data });
      this.table.dataTable = $("#" + this.table.id).DataTable(this.table.configuration);
      const vm = this;
      this.table.dataTable
        .on("click", "tr", function(e, dt, type, indexes) {
          vm.table.rowSelected = true;
          var rowData = vm.table.dataTable
            .rows(this)
            .data()
            .toArray();
          $("#" + vm.table.id + " .selected").removeClass("selected");
          $(this).toggleClass("selected");
          if (!$.isEmptyObject(rowData)) {
            vm.table.rowSelectedId = rowData[0].id;
            vm.postRowSelect(rowData[0], true);
          }
        })
        .on("deselect", function(e, dt, type, indexes) {
          vm.table.rowSelected = false;
          vm.table.rowSelectedId = 0;
          if ($(this).hasClass("selected")) {
            $(this).removeClass("selected");
          }
          var rowData = vm.table.dataTable
            .rows(this)
            .data()
            .toArray();
          if (!$.isEmptyObject(rowData)) {
            vm.postRowSelect(rowData[0], false);
          }
        });
      this.buildResponsiveTable();
    },

    loadData() {
      this.getTableData();
      this.table.configuration.order = [[5, "desc"]];
      this.table.configuration.dom = "frtpB";
      this.table.configuration.responsive = false;
    }
  },
  computed: {},
  created() {
    if (this.isAdmin) {
      this.loadData();
    }
  },
  props: {},
  mounted() {}
};
</script>
